<template>
  <div class="pages" v-loading="listLoading">
    <div v-for="(item, index) in templateData.TemplateContent.Controls" :key="index">
      <Percentage v-if="item.Property.Control === 'Percentage'" :data-val="item"></Percentage>
      <Digit v-if="item.Property.Control == 'Number'" :data-val="item"></Digit>
      <Contact v-if="item.Property.Control == 'Condition'" :data-val="item"></Contact>
      <Dates v-if="item.Property.Control == 'Date'" :data-val="item"></Dates>
      <Version v-if="item.Property.Control == 'Text'" @child-event="getTextVal" :data-val="item"></Version>
      <Money v-if="item.Property.Control == 'Money'" :data-val="item"></Money>
      <Tips v-if="item.Property.Control == 'Tips'" :data-val="item"></Tips>
      <File v-if="item.Property.Control == 'File'" :data-val="item"></File>
      <Table v-if="item.Property.Control == 'Table'" @child-event="tableOperation" :data-val="item"
        :template-data="templateData"></Table>
      <Selector v-if="item.Property.Control == 'Selector'" @child-event="getSelectorVal" :data-val="item"></Selector>
      <Textarea v-if="item.Property.Control == 'Textarea'" :data-val="item"></Textarea>
      <Choose v-if="item.Property.Control == 'Contact'" @child-event="clickChoose" :data-val="item"></Choose>
    </div>

    <Button class="submit-process" v-on:click="submitA" v-bind:disabled="isDisabled" v-bind:loading="formLoading"
      size="large" type="primary">
      提交
    </Button>
  </div>
</template>

<script>
/**
 * Version 为Text文本组件
 */
import Digit from "../components/Number.vue";
import Contact from "../components/Contact.vue";
import Dates from "../components/Date.vue";
import Version from "../components/Text.vue";
import Money from "../components/Money.vue";
import Tips from "../components/Tips.vue";
import File from "../components/File.vue";
import Table from "../components/Table.vue";
import Selector from "../components/Selector.vue";
import Textarea from "../components/Textarea.vue";
import Choose from "../components/Choose.vue";
import Percentage from "../components/Percentage";
import SelectFilterTable from "../components/SelectFilterTable.vue";
import wx from "weixin-js-sdk";
import stringUtils from "../assets/js/stringUtil.js";

import { initWxConfig } from "../api/jssdk.js";
import {
  getTemplateInfo,
  submitProcess,
  getAdministrativeProgressive,
} from "@/api/approval";
import {
  getAllocationTemplatePagers,
  getTemplateDetail,
  getAllocationTableHeaderDto,
  getFlowsTableDetail,
  getEmployeeFill,
} from "@/api/allocation";
import {
  getDepartmentInfo,
  getDepartmentRelationByStructs,
} from "@/api/department";
import { getRelation, getEmpInfo } from "@/api/employee";

var isSubmit = false;

var template = {
  TemplateContent: {
    Controls: [],
  },
};
export default {
  components: {
    Contact,
    Dates,
    Version,
    Money,
    Tips,
    File,
    Table,
    Digit,
    Selector,
    Textarea,
    Choose,
    Percentage
  },
  data() {
    return {
      templateData: template,
      relationList: null,
      logInfo: null,
      templateId: "",
      spNo: null,
      formLoading: false,
      listLoading: false,
      isDisabled: false,
      hierarchyCopy: null,
      deptCopy: null,
      id: null,
      fyVal: null,
      status: null,
      fyValKey: null,
      dataType: null,
      noDatas: [],
      resData: null,
      statusMap: new Map(),
    };
  },
  created() {
    stringUtils.setAddIsShow(null);
    initWxConfig(this);
    this.logInfo = this.getLoginUserInfo();
    this.templateId = this.$route.query.templateId;
    this.spNo = this.$route.query.spNo;
    this.id = this.$route.query.id;
    this.status = this.$route.query.status;
    this.dataType = this.$route.query.dataType;
    this.operator = this.$route.query.operator;
    this.getEmployeeRelation(this.logInfo.EmpNo);
  },
  methods: {
    //方法
    clickChoose: async function (dataVal, name) {
      var that = this;
      window.wx.invoke(
        "selectEnterpriseContact",
        {
          fromDepartmentId: 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
          mode: "single", // 必填，选择模式，single表示单选，multi表示多选
          type: ["user"], // 必填，选择限制类型，指定department、user中的一个或者多个
          selectedDepartmentIds: [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
          selectedUserIds: [], // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
        },
        async function (res) {
          if (res.err_msg == "selectEnterpriseContact:ok") {
            if (typeof res.result == "string") {
              res.result = JSON.parse(res.result); //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
            }
            var user = res.result.userList[0];
            dataVal.Values.push([user.id, user.name]);
            dataVal.Value = user.name;
          }
        }
      );
    },
    getTemplate: async function () {
      //判断是否是IOS
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        var oDate = new Date();
        oDate.setDate(oDate.getDate() + 7200);
        document.cookie = `logInfo=${encodeURI(JSON.stringify(this.logInfo))};expires=${oDate.toDateString()}`
      }
      var departs = this.logInfo.fullName;
      var empNo = this.logInfo.EmpNo;
      let account = this.logInfo.EmpNo.toLowerCase();
      let zStatu = "";
      await getFlowsTableDetail(this.id).then((res) => {
        this.resData = res;
        let flowsStatu = res.body.flowsStatus;
        switch (flowsStatu) {
          case 100:
            zStatu = "Apply";
            break;
          case 200:
            zStatu = "AllocationFill";
            break;
          case 210:
            zStatu = "AllocationFillTwo";
            break;
          case 90:
            zStatu = "BasicReject";
            break;
          default:
            zStatu = "NULL";
            break;
        }
      });

      if (this.status == "AllocationFill") {
        let isDis = false;
        let approvals = this.resData.body.approvalInfo.approvals;
        let disDatas = approvals[approvals.length - 1].approvals;
        disDatas.forEach((item) => {
          if ((item.empNo || "").toUpperCase() == (this.logInfo.EmpNo || "").toUpperCase()) {
            isDis = true;
          }
        });
        if (isDis) {
          this.Message({
            message: "已申请，请勿重复申请!",
            type: "error",
            duration: 1000,
          });
          this.isDisabled = true;
        }
      }
      if (
        this.status == "Apply" ||
        this.status == "AllocationFill" ||
        this.status == "BasicReject"
      ) {
        if (
          account != this.operator.toLowerCase() &&
          this.isDisabled == false
        ) {
          this.Message({
            message: "没有申请权限",
            type: "error",
            duration: 1000,
          });
          this.isDisabled = true;
        }
      }
      if (this.status == "Apply") {
        var commissionAAuth = this.$store.state.secondaryCommissionAuth.commissionA;
        if (
          !commissionAAuth.apply.includes(empNo) &&
          this.isDisabled == false
        ) {
          this.Message({
            message: "没有申请权限",
            type: "error",
            duration: 1000,
          });
          this.isDisabled = true;
        }
        if (this.resData.body.applicantNo != this.logInfo.EmpNo) {
          this.Message({
            message: "没有申请权限",
            type: "error",
            duration: 1000,
          });
          this.isDisabled = true;
        }
      }
      let checking = [];
      let isPass = true;
      //this.resData
      let headers = this.resData.body.allocationTable.headerExtensions;
      headers.forEach((item) => {
        if (item.key.indexOf("填写人") > -1) {
          checking.push(item.value);
        }
      });
      checking.forEach((item) => {
        if (item.toLowerCase() == account) {
          isPass = false;
        }
      });
      //部门名称
      this.listLoading = true;
      var title = this.logInfo.fullName;
      var jobLevel = this.logInfo.JobLevel;
      await getTemplateInfo(this.templateId).then(async (response) => {
        var controls = response.Body;
        var cols = controls.TemplateContent.Controls;
        this.TemplateCopy(cols);

        cols.splice(18, cols.length - 18);
        console.log("-18");


        let depts = [];
        await getFlowsTableDetail(this.id).then((res) => {
          let alltable = res.body.allocationTable;
          alltable.headerExtensions.forEach((item) => {
            depts.push(item);
          });
          cols.forEach(async (col, index) => {
            if (col.Property.Title[0].Text.indexOf("分佣比例类型") > -1) {
              col.Value = alltable.commissionRateType;
              this.fyValKey = alltable.commissionRateTypeId;
              col.Disable = true;
            }
            if (col.Property.Title[0].Text.indexOf("项目名称") > -1) {
              col.Value = alltable.projectName;
              col.Disable = true;
            }
            if (col.Property.Title[0].Text.indexOf("类别") > -1) {
              col.Config.Selector.Options.forEach((item) => {
                if (item.Value[0].Text == alltable.projectType) {
                  col.Value = item.Key;
                }
              });
              col.Disable = true;
            }
            if (
              col.Property.Title[0].Text.indexOf("是否在以后销售佣金中抵扣") >
              -1
            ) {
              if (alltable.laterCommissionDeduction === null) {
                col.Property.Control = "Text";
                col.Value = "";
                col.Property.Placeholder[0].Text = " ";
              } else {
                if (!alltable.laterCommissionDeduction) {
                  let ops = col.Config.Selector.Options;
                  ops.forEach((item) => {
                    if (item.Value[0].Text == "否") {
                      col.Value = item.Key;
                    }
                  });
                } else {
                  let ops = col.Config.Selector.Options;
                  ops.forEach((item) => {
                    if (item.Value[0].Text == "是") {
                      col.Value = item.Key;
                    }
                  });
                }
              }
              col.Disable = true;
            }
            if (col.Property.Title[0].Text.indexOf("开发商名称") > -1) {
              col.Value = alltable.developersName;
              this.$set(col.Property.Placeholder[0], "Text", " ")
              col.Disable = true;
            }
            if (col.Property.Title[0].Text.indexOf("对外分佣") > -1) {
              col.Value = alltable.externalCommission;
              this.$set(col.Property.Placeholder[0], "Text", " ")
              col.Disable = true;
              col.IsShow = false;
            }
            if (col.Property.Title[0].Text.indexOf("转介费") > -1) {
              col.Value = alltable.referralFee;
              this.$set(col.Property.Placeholder[0], "Text", " ")
              col.Disable = true;
              col.IsShow = false;
            }
            if (col.Property.Title[0].Text.indexOf("成交编号") > -1) {
              col.Value = alltable.contractNo;
              this.$set(col.Property.Placeholder[0], "Text", " ")
              col.Disable = true;
            }
            if (col.Property.Title[0].Text.indexOf("盘源类型") > -1) {
              col.Value = alltable.buildType === "" ? "无" : alltable.buildType;
              col.Disable = true;
            }
            if (col.Property.Title[0].Text.indexOf("请选择营运部总经理") > -1) {
              let papp = alltable.projectApproval;
              col.Values = [];
              col.Values.push([papp.key, papp.value]);
              col.Value = papp.value;
              col.IsShow = false;
            }
            if (col.Property.Title[0].Text.indexOf("代理类型") > -1) {
              if (alltable.agencyType === "") {
                col.Property.Control = "Text";
                col.Value = "";
                col.Property.Placeholder[0].Text = " ";
              } else {
                col.Config.Selector.Options.forEach((item) => {
                  if (item.Value[0].Text == alltable.agencyType) {
                    col.Value = item.Key;
                  }
                });
              }
              col.Disable = true;
            }
            if (col.Property.Title[0].Text.indexOf("品牌顾问策划项目") > -1) {
              if (alltable.brandConsultantPlanningProject === null) {
                col.Property.Control = "Text";
                col.Value = "";
                col.Property.Placeholder[0].Text = " ";
              } else {
                if (!alltable.brandConsultantPlanningProject) {
                  let ops = col.Config.Selector.Options;
                  ops.forEach((item) => {
                    if (item.Value[0].Text == "否") {
                      col.Value = item.Key;
                    }
                  });
                } else {
                  let ops = col.Config.Selector.Options;
                  ops.forEach((item) => {
                    if (item.Value[0].Text == "是") {
                      col.Value = item.Key;
                    }
                  });
                }
              }
              col.Disable = true;
            }
            if (col.Property.Title[0].Text.indexOf("计佣区域") > -1) {
              if (alltable.commissionArea === "") {
                col.Property.Control = "Text";
                col.Value = "";
                col.Property.Placeholder[0].Text = " ";
              } else {
                col.Config.Selector.Options.forEach((item) => {
                  if (item.Value[0].Text == alltable.commissionArea) {
                    col.Value = item.Key;
                  }
                });
              }
              col.Disable = true;
            }
            if (col.Property.Title[0].Text.indexOf("申请变更日期") > -1) {
              alltable.applyChangeDate = alltable.applyChangeDate.substring(
                0,
                10
              );
              col.Value = alltable.applyChangeDate;
              col.Disable = true;
            }
            if (col.Property.Title[0].Text.indexOf("备注") > -1) {
              col.Value = alltable.remarks;
              this.$set(col.Property.Placeholder[0], "Text", " ")
              col.Disable = true;
            }
          });
        });
        var that = this;
        if (this.status == "Apply" && this.resData.body.dataType != 20) {
          var that = this;
          await getTemplateDetail(that.fyValKey).then((res) => {
            cols.splice(17, cols.length - 17);
            console.log("-17");
            cols.forEach((col) => {
              console.log(col.Property.Title[0].Text);
            })
            let details = res.body.allocationDetails;
            cols.forEach((item, index) => {
              if (item.Property.Title[0].Text.indexOf("分佣比例类型") > -1) {
                item.Value = res.body.templateName;
              }
            });
            let deptnss = [];
            let deptName = "";
            let deptns = [];
            let deptP = [];
            let newDepts = [];
            depts.forEach((dept) => {
              if (dept.isMark) {
                if (deptName != "") {
                  deptName += "-";
                }
                deptName += dept.value;
                if (!deptnss.includes(dept.key)) {
                  deptnss.push(dept.key);
                  deptns.push(`${dept.key}/` + deptName);
                  deptName = "";
                }
                /* deptns.push(`${dept.key}/${dept.value}`);*/
              } else {
                deptP.push({
                  Key: dept.key.replace("填写人", ""),
                  Value: dept.value,
                });
              }
            });
            deptns.forEach((dept) => {
              deptP.forEach((deptp) => {
                if (dept.split("/")[0] == deptp.Key) {
                  newDepts.push({
                    key: dept,
                    value: deptp.Value,
                  });
                }
              });
            });

            depts = newDepts;
            depts.forEach((dept) => {
              this.deptCopy.Property.Title[0].Text = `${dept.key.split("/")[0]
                }数据填写`;
              let childrens = this.deptCopy.Config.Table.Children;
              for (let i = 0; i < childrens.length; i++) {
                let item = childrens[i];
                if (item.Property.Title[0].Text.indexOf("部门名称") > -1) {
                  item.Disable = true;
                  item.Property.Control = "Text";
                  item.Value = dept.key;
                }
                if (
                  item.Property.Title[0].Text.indexOf("部门数据填写人") > -1
                ) {
                  item.Property.Control = "Text";
                  item.filterable = false;
                  item.Disable = true;
                  item.Value = dept.value.split("-")[1];
                }
              }
              this.$set(this.deptCopy, "addIsShow", false)
              cols.push(this.deptCopy);
              let deptData = JSON.stringify(this.deptCopy);
              this.deptCopy = JSON.parse(deptData);
            });
            details.forEach(async (detail) => {
              var reg = /[\u4e00-\u9fa5]/g;
              let fy = `${detail.deptName}/${detail.roleType}分佣信息`;
              // var names = fy.match(reg).join("");
              this.hierarchyCopy.Property.Title[0].Text = fy;
              let childrens = this.hierarchyCopy.Config.Table.Children;
              childrens.forEach((item) => {
                if (item.Property.Title[0].Text.indexOf("角色层级") > -1) {
                  item.Disable = true;
                  item.Value = detail.roleType;
                }
                if (item.Property.Title[0].Text.indexOf("员工工号") > -1) {
                  item.Property.Control = "Text";
                  item.filterable = false;
                  item.Property.Control = "Selector";
                  item.IsEmpAndPer = true;
                  item.filterable = true;
                }
                if (item.Property.Title[0].Text.indexOf("员工姓名") > -1) {
                  item.Disable = true;
                }
                if (item.Property.Title[0].Text.indexOf("角色计佣比例") > -1) {
                  item.Disable = true;
                  item.Value = detail.roleRate;
                }
                if (item.Property.Title[0].Text.indexOf("个人比率(%)") > -1) {
                  item.Property.Control = 'Percentage'
                }
                if (item.Property.Title[0].Text.indexOf("部门分佣比例") > -1) {
                  item.Value = detail.deptRate;
                  item.Disable = true;
                  item.IsShow = false;
                }
              });
              let data = JSON.stringify(this.hierarchyCopy);
              cols.push(JSON.parse(data));
            });
          });
        } else if (
          this.status == "AllocationFill" ||
          this.status == "BasicReject" ||
          this.resData.body.dataType == 20
        ) {
          var that = this;
          var disModule = [];
          var flowsStatu = 200;
          await getFlowsTableDetail(this.id).then((res) => {
            flowsStatu = res.body.flowsStatus;
            let disRows = res.body.rows;

            if (this.status == "BasicReject" || this.resData.dataType == 20) {
              if (
                res.body.approvalInfo.approvals[0].approvals[0].empNo !=
                this.logInfo.EmpNo
              ) {
                this.Message({
                  message: "没有申请权限",
                  type: "error",
                  duration: 1000,
                });
                this.isDisabled = true;
              }
            }
            disRows.forEach((disRow) => {
              if (
                (disRow.signed == "SC09110035" ||
                  disRow.signed == "SC12050030" ||
                  disRow.signed == "SC16005075" ||
                  disRow.signed == "SC17001763" ||
                  disRow.signed == "SC18002633" ||
                  disRow.signed == "SC19004201") &&
                disRow.time != 2
              )
                if (!disModule.includes(disRow.roleName)) {
                  disModule.push(disRow.roleName);
                }
            });
            let deptns = [];
            let deptP = [];
            let newDepts = [];

            depts.forEach((dept) => {
              if (dept.isMark) {
                deptns.push(`${dept.key}/${dept.value}`);
              } else {
                deptP.push({
                  Key: dept.key.replace("填写人", ""),
                  Value: dept.value,
                });
              }
            });
            deptns.forEach((dept) => {
              deptP.forEach((deptp) => {
                if (dept.split("/")[0] == deptp.Key) {
                  newDepts.push({
                    key: dept,
                    value: deptp.Value,
                  });
                }
              });
            });
            depts = newDepts;
            if (this.status == "AllocationFill") {
              let deptArr = [];
              newDepts.forEach((dept) => {
                deptArr.push(dept.value.split("-")[0]);
              });
              if (!deptArr.includes(this.logInfo.EmpNo)) {
                this.isDisabled = true;
              }
            }
            depts.forEach((dept) => {
              this.deptCopy.Property.Title[0].Text = `${dept.key.split("/")[0]}数据填写`;
              let childrens = this.deptCopy.Config.Table.Children;
              childrens.forEach((item) => {
                if (item.Property.Title[0].Text.indexOf("部门名称") > -1) {
                  item.Disable = true;
                  item.Value = dept.key;
                }
                if (
                  item.Property.Title[0].Text.indexOf("部门数据填写人") > -1
                ) {
                  item.Property.Control = "Text";
                  item.filterable = false;
                  item.Disable = true;
                  item.Value = dept.value.split("-")[1];
                  // getEmpInfo(dept.value).then((empInfo) => {
                  //   item.Value = empInfo.Body[0].EmpName;
                  // });
                }
              });
              cols.push(this.deptCopy);
              let deptData = JSON.stringify(this.deptCopy);
              this.deptCopy = JSON.parse(deptData);
            });
          });
          if (flowsStatu != 90 || this.resData.dataType == 20) {
            await getTemplateDetail(that.fyValKey).then(async (res) => {
              let details = res.body.allocationDetails;
              let inxs = [];
              details.forEach((detail, index) => {
                if (disModule.includes(detail.roleType)) {
                  inxs.push(index);
                }
              });
              inxs.reverse();
              inxs.forEach((inx) => {
                details.splice(inx, 1);
              });
              let DeptName = "";
              let hExtensions = this.resData.body.allocationTable
                .headerExtensions;
              hExtensions.forEach((headerExtension) => {
                if (headerExtension.value.split("-")[0] == this.logInfo.EmpNo) {
                  DeptName = headerExtension.key.replace("填写人", "");
                }
              });
              let newDetails = [];
              details.forEach((detail) => {
                if (detail.deptName == DeptName) {
                  newDetails.push(detail);
                }
              });
              details = newDetails;


              for (let i = 0; i < details.length; i++) {
                let detail = details[i];
                // var reg = /[\u4e00-\u9fa5]/g;
                let fy = `${detail.deptName}/${detail.roleType}分佣信息`;
                // var names = fy.match(reg).join("");
                that.hierarchyCopy.Property.Title[0].Text = fy;
                const RandomId = (len) =>
                  Math.random().toString(36).substr(3, len);
                that.hierarchyCopy.Id = `Table-${RandomId(10)}`;
                let childrens = that.hierarchyCopy.Config.Table.Children;
                for (const item of childrens) {
                  if (item.Property.Title[0].Text.indexOf("角色层级") > -1) {
                    item.Disable = true;
                    item.Value = detail.roleType;
                  }
                  if (item.Property.Title[0].Text.indexOf("员工工号") > -1) {
                    item.Property.Control = "Text";
                    item.filterable = false;
                    item.Property.Control = "Selector";
                    item.IsEmpAndPer = true;
                    item.filterable = true;
                    item.Property.Require = 1;
                  }
                  if (item.Property.Title[0].Text.indexOf("员工姓名") > -1) {
                    item.Disable = true;
                    item.Property.Require = 1;
                  }
                  if (
                    item.Property.Title[0].Text.indexOf("角色计佣比例") > -1
                  ) {
                    item.Disable = true;
                    item.Value = detail.roleRate;
                    item.Property.Require = 1;
                  }
                  if (
                    item.Property.Title[0].Text.indexOf("部门分佣比例") > -1
                  ) {
                    item.Value = detail.deptRate;
                    item.Disable = true;
                    item.IsShow = false;
                    item.Property.Require = 1;
                  }
                  if (item.Property.Title[0].Text.indexOf("个人比率(%)") > -1) {
                    item.Property.Require = 1;
                    item.Property.Control = "Percentage";
                  }
                }
                let data = JSON.stringify(that.hierarchyCopy);
                cols.push(JSON.parse(data));
              }
            });
            let DelIndexsData = [];

            await getFlowsTableDetail(that.id).then((res) => {
              let disCol = false;
              let approvals = res.body.approvalInfo.approvals;
              approvals.forEach((app) => {
                if (app.description == "分佣明细填写完成【分佣拒绝】") {
                  disCol = true;
                }
              });
              if (disCol) {
                cols.forEach((col, index) => {
                  if (col.Property.Title[0].Text.indexOf("分佣信息") > -1) {
                    DelIndexsData.push(index);
                  }
                });
              }
            });
            DelIndexsData = DelIndexsData.reverse();
            DelIndexsData.forEach((item) => {
              cols.splice(item, 1);
            });
          }
          //获取后台数据渲染
          if (that.id !== undefined && that.id !== null) {
            //移除现有分佣信息模块
            // console.log("移除现有分佣信息模块")
            // cols.reverse()
            // for (let i = 0; i < cols.length; i++) {
            //   let item = cols[i]
            //   if (item.Property.Title[0].Text.indexOf("分佣信息") > -1){
            //     console.log(JSON.parse(JSON.stringify(item)))
            //     cols.splice(i,1)
            //   }
            // }
            // cols.reverse()
            await getFlowsTableDetail(that.id).then(async (res) => {
              let cMap = new Map();
              let details = res.body.rows;
              if (res.body.dataType === 20) {
                let _commissionRateTypeId = res.body.allocationTable.commissionRateTypeId;
                await getTemplateDetail(_commissionRateTypeId).then(resp => {
                  let tempData = resp.body.allocationDetails;
                  for (let i = 0; i < details.length; i++) {
                    let resArray = tempData.filter(t => t.roleType === details[i].roleName)
                    if (resArray.length !== 0) {
                      details[i].deptRate = resArray[0].deptRate;
                      details[i].roleRate = resArray[0].roleRate;
                    }
                  }
                })
              }
              let datas = [];
              let colData = [];
              let delIndexs = [];
              for (let i = 0; i < details.length; i++) {
                let detail = details[i];
                if (detail.signed == this.logInfo.EmpNo) {
                  datas.push(detail);
                } else {
                  this.noDatas.push(detail);
                }
              }

              datas.forEach((data) => {
                if (data.approvalStatus != null && data.approvalTime != null) {
                  // let remark = data.remark === null ? "" : data.remark;
                  let Vflag = `${data.empNo}-${data.deptName}-${data.personRate}`;
                  if (this.statusMap.get(Vflag) == undefined) {
                    this.statusMap.set(
                      Vflag,
                      `${data.approvalStatus}@${data.approvalTime}`
                    );
                  }
                }
              });
              var xList = []
              for (let i = 0; i < datas.length; i++) {
                let data = datas[i];
                let x = `${data.deptName}/${data.roleName}分佣信息`;
                xList.push(x)
              }


              for (let index = 0; index < cols.length; index++) {
                let col = cols[index];
                if (col.Property.Title[0].Text.indexOf("分佣信息") > -1) {
                  if (xList.indexOf(col.Property.Title[0].Text) > -1) {
                    if (!delIndexs.includes(index)) {
                      delIndexs.push(index);
                    }
                  }
                }
              }


              delIndexs.reverse();
              for (let i = 0; i < delIndexs.length; i++) {
                let delIndex = delIndexs[i];
                cols.splice(delIndex, 1);
              }
              let deleteInx = [];
              for (let inx = 0; inx < cols.length; inx++) {
                let col = cols[inx];
                if (col.Property.Title[0].Text.indexOf("分佣信息") > -1) {
                  deleteInx.push(inx);
                }
              }
              if (datas.length > 0) {
                datas.forEach((data, index) => {
                  if (cMap.get(data.roleName) == undefined) {
                    cMap.set(data.roleName, "");
                  } else {
                    let val = cMap.get(data.roleName);
                    if (val == "") {
                      cMap.set(data.roleName, 1);
                    } else {
                      cMap.set(data.roleName, cMap.get(data.roleName) + 1);
                    }
                  }
                  // var reg = /[\u4e00-\u9fa5]/g;
                  // let mdata = data.roleName.match(reg).join("");
                  let fy = `${data.deptName}/${data.roleName}分佣信息${cMap.get(
                    data.roleName
                  )}`;
                  var names = fy;
                  this.hierarchyCopy.Property.Title[0].Text = names;
                  const RandomId = (len) =>
                    Math.random().toString(36).substr(3, len);
                  that.hierarchyCopy.Id = `Table-${RandomId(10)}`;
                  if (cMap.get(data.roleName) != "") {
                    this.hierarchyCopy.deleteIsShow = true;
                  } else {
                    this.hierarchyCopy.deleteIsShow = false;
                  }
                  let childrens = this.hierarchyCopy.Config.Table.Children;
                  childrens.forEach((item) => {
                    if (item.Property.Title[0].Text.indexOf("角色层级") > -1) {
                      item.Disable = true;
                      item.Value = data.roleName;
                    }
                    if (item.Property.Title[0].Text.indexOf("个人比率(%)") > -1) {
                      item.Property.Control = "Percentage";
                      item.Disable = false;
                      item.Value = this.multiply(data.personRate, 100, 2)
                    }
                    if (item.Property.Title[0].Text.indexOf("员工姓名") > -1) {
                      item.Disable = false;
                      item.Value = data.empName;
                    }
                    if (item.Property.Title[0].Text.indexOf("员工工号") > -1) {
                      if (this.status == "xxxx") {
                        item.Disable = true;
                        item.Property.Control = "Text";
                        item.filterable = false;
                      } else {
                        item.Property.Control = "Selector";
                        item.filterable = true;
                        item.Disable = false;
                        item.IsEmpAndPer = true;
                        item.Value = `${data.empNo}-${data.empName}`;
                        this.$set(item, 'Options', [
                          { Key: `${data.empNo}-${data.empName}`, Value: `${data.empNo}-${data.empName}` }
                        ]);
                        this.$set(item, 'value', {
                          Key: `${data.empNo}-${data.empName}`,
                          Value: `${data.empNo}-${data.empName}`
                        });
                      }

                    }
                    if (
                      item.Property.Title[0].Text.indexOf("角色计佣比例") > -1
                    ) {
                      item.Disable = true;
                      item.Value = data.roleRate;
                    }
                    if (
                      item.Property.Title[0].Text.indexOf("部门分佣比例") > -1
                    ) {
                      item.Value = data.deptRate;
                      item.Disable = true;
                      item.IsShow = false;
                    }
                    if (item.Property.Title[0].Text.indexOf("备注") > -1) {
                      item.Disable = false;
                      item.Value = data.remark;
                    }
                  });
                  cols.push(this.hierarchyCopy);
                  let hireData = JSON.stringify(this.hierarchyCopy);
                  this.hierarchyCopy = JSON.parse(hireData);
                });
              }
            });
          }

        }

        that.templateData = await that.assignControl(controls, this.logInfo);
        that.listLoading = false;
        for (let index = 0; index < cols.length; index++) {
          let item = cols[index];
          if (item.Property.Title[0].Text.indexOf("数据填写") > -1) {
            this.$set(item, "addIsShow", false)
          }
        }
      });
    },
    getEmployeeRelation: async function (empNo) {
      await getRelation(empNo).then((response) => {
        this.relationList = response.Body[0].Nodes;
      });
    },
    RetainTwo(value) {
      let strValue = String(value);
      let retain = strValue.indexOf(".");
      let newRetain = strValue.substring(0, retain + 3);
      return newRetain;
    },
    TemplateCopy(cols) {
      cols.forEach(async (item, index) => {
        if (item.Property.Title[0].Text.indexOf("部门数据填写") > -1) {
          let childrens = item.Config.Table.Children;
          item.addIsShow = false;
          //深拷贝
          let deptData = JSON.stringify(item);
          this.deptCopy = JSON.parse(deptData);
          item.IsShow = false;
        }
        if (item.Property.Title[0].Text.indexOf("分佣信息") > -1) {
          let childrens = item.Config.Table.Children;
          childrens.forEach((item) => {
            if (item.Property.Title[0].Text.indexOf("角色层级") > -1) {
              item.Disable = true;
              item.Value = "后台数据";
            }
            if (item.Property.Title[0].Text.indexOf("角色计佣比例") > -1) {
              // item.Property.Control = "Percentage";
              item.Disable = true;
              item.Value = "后台数据";
            }
            if (item.Property.Title[0].Text.indexOf("部门分佣比例") > -1) {
              item.Value = "后台数据";
              item.Disable = true;
            }
          });
          item.addIsShow = true;
          let hierarData = JSON.stringify(item);
          this.hierarchyCopy = JSON.parse(hierarData);

          item.IsShow = false;
        }
      });
    },
    getTextVal() { },
    getSelectorVal: async function (val, name) {
      let isNull = "无";
      var that = this;
      var depts = [];
      //角色层级
      var hierarchys = [];
      let query = null;
      if (name == "secom") {
        this.fyVal = val.label;
        this.fyValKey = val.value;
        await getTemplateDetail(val.value).then((res) => {
          let cols = that.templateData.TemplateContent.Controls;
          if (this.id == null) {
            cols.splice(14, cols.length - 14);
          } else {
            cols.splice(17, cols.length - 17);
          }
          let details = res.body.allocationDetails;
          details.forEach((detail, index) => {
            if (detail.buildType != "无") {
              isNull = detail.buildType;
            }
            if (!depts.includes(detail.deptName)) {
              depts.push(detail.deptName);
            }
          });
          cols.forEach((item) => {
            if (item.Property.Title[0].Text.indexOf("盘源类型") > -1) {
              item.Value = isNull;
              item.Disable = true;
            }
          });
          depts.forEach((deptName) => {
            this.deptCopy.Property.Title[0].Text = `${deptName}数据填写`;
            let childrens = this.deptCopy.Config.Table.Children;
            childrens.forEach((item) => {
              if (item.Property.Title[0].Text.indexOf("部门名称") > -1) {
                item.Disable = true;
                item.Value = deptName;
              }
              if (item.Property.Title[0].Text.indexOf("个人比率(%)") > -1) {
                item.Property.Control = "Percentage";
                item.Disable = true;
                item.Value = deptName;
              }
              if (item.Property.Title[0].Text.indexOf("部门数据填写人") > -1) {
                item.Property.Control = "Selector";
                item.filterable = true;
                item.IsDeptPer = true;
              }
            });
            cols.push(this.deptCopy);
            let deptData = JSON.stringify(this.deptCopy);
            this.deptCopy = JSON.parse(deptData);
          });
        });
      }
      this.templateData.TemplateContent.Controls.forEach((e) => {
        if (e.Property.Title[0].Text.indexOf("数据填写") > -1) {
          e.addIsShow = false;
        }
      });
    },
    /**
     * 解析字符串转为对应的数组
     * @param val
     * @returns {number|string|[]}
     */
    parseString(val) {
      let values = [];
      if (val.indexOf("-") > -1) {
        let n = (val.split('-')).length - 1;
        if (n === 1) {
          let vals = val.split("-");
          for (let i = 0; i < vals.length; i++) {
            let v = vals[i];
            let result = this.parsePercent(v);
            if (!isNaN(result)) {
              values.push(result)
            } else {
              return result;
            }
          }
          return values;
        }
        return "不能有多个-"
      } else {
        let result = this.parsePercent(val);
        if (!isNaN(result)) {
          values.push(result);
          return values;
        }
        return result;
      }
    },
    /**
     * 去掉%并将值乘以一百保留四位小数
     * @param val
     * @returns {string|number}
     */
    parsePercent(val) {
      if (val.indexOf("%") > -1) {
        let n = (val.split('%')).length - 1;
        if (n === 1) {
          let newVal = val.replace("%", "");
          if (newVal !== "") {
            if (!isNaN(newVal)) {
              return Number((parseFloat(newVal.trim()) / 100).toFixed(4));
            }
          }
          return "无法转换为数字，请检查输入格式";
        }
        return "多个%";
      } else {
        return "缺少%";
      }
    },
    getMaxBoundary(val, flag) {
      if (!flag) {
        if (val.length === 2) {
          return val[1];
        }
        return val;
      }
      if (val.length === 2) {
        return `${val[0]}-${val[1]}`
      }
      return val[0];
    },
    parseArrayToStringForFloat(val) {
      const valOneResult = this.multiply(val[0], 100, 2)
      if (val.length === 2) {
        return `${valOneResult}%-${this.multiply(val[1], 100, 2)}%`
      }
      return `${valOneResult}%`
    },
    tableOperation: async function (val, type, datas) {
      if (type == "seno") {
        let dept = datas.Property.Title[0].Text;
        this.templateData.TemplateContent.Controls.forEach((e) => {
          if (e.Property.Title[0].Text == dept) {
            let childs = e.Config.Table.Children;
            childs.forEach((item) => {
              if (item.Property.Title[0].Text == "员工工号") {
                item.Value = val.value;
              }
              if (item.Property.Title[0].Text == "员工姓名") {
                item.Value = val.value.split("-")[1];
              }
            });
          }
        });
      } else if (type == "clearEmp") {
        let childs = datas.Config.Table.Children;
        childs.forEach((child) => {
          if (child.Property.Title[0].Text == "员工姓名") {
            child.Value = "";
          }
        });
      } else {
        if (type == "add") {
          type = "addAndVal";
        }
        if (type == "delete") {
          type = "delAndVal";
        }
        await this.tableoperation(val, type, datas, this);
      }
    },
    isInteger(obj) {
      return Math.floor(obj) === obj
    },
    toInteger(floatNum) {
      var ret = { times: 1, num: 0 }
      var isNegative = floatNum < 0
      if (this.isInteger(floatNum)) {
        ret.num = floatNum
        return ret
      }
      var strfi = floatNum + ''
      var dotPos = strfi.indexOf('.')
      var len = strfi.substr(dotPos + 1).length
      var times = Math.pow(10, len)
      var intNum = parseInt(Math.abs(floatNum) * times + 0.5, 10)
      ret.times = times
      if (isNegative) {
        intNum = -intNum
      }
      ret.num = intNum
      return ret
    },
    operation(a, b, digits, op) {
      var o1 = this.toInteger(a)
      var o2 = this.toInteger(b)
      var n1 = o1.num
      var n2 = o2.num
      var t1 = o1.times
      var t2 = o2.times
      var max = t1 > t2 ? t1 : t2
      var result = null
      switch (op) {
        case 'add':
          if (t1 === t2) { // 两个小数位数相同
            result = n1 + n2
          } else if (t1 > t2) { // o1 小数位 大于 o2
            result = n1 + n2 * (t1 / t2)
          } else { // o1 小数位 小于 o2
            result = n1 * (t2 / t1) + n2
          }
          return result / max
        case 'subtract':
          if (t1 === t2) {
            result = n1 - n2
          } else if (t1 > t2) {
            result = n1 - n2 * (t1 / t2)
          } else {
            result = n1 * (t2 / t1) - n2
          }
          return result / max
        case 'multiply':
          result = (n1 * n2) / (t1 * t2)
          return result
        case 'divide':
          result = (n1 / n2) * (t2 / t1)
          return result
      }
    },
    add(a, b, digits) {
      return this.operation(a, b, digits, 'add')
    },
    multiply(a, b, digits) {
      return this.operation(a, b, digits, 'multiply')
    },
    submitA: function () {
      let isDis = false;
      let that = this;
      if (that.status == "AllocationFill") {
        getFlowsTableDetail(that.id).then((res) => {
          let approvals = res.body.approvalInfo.approvals;
          let disDatas = approvals[approvals.length - 1].approvals;
          disDatas.forEach((item) => {
            if ((item.empNo || "").toUpperCase() == (that.logInfo.EmpNo || "").toUpperCase()) {
              isDis = true;
            }
          });
          if (isDis) {
            that.Message({
              message: "已申请，请勿重复申请!",
              type: "error",
              duration: 1000,
            });
            that.isDisabled = true;
          } else {
            that.submit();
          }
        });
      } else {
        that.submit();
      }
    },
    submit: function () {
      this.isDisabled = true;
      var data = {
        //填充状态
        FillStatus: 0,
        //项目名称
        ProjectName: "",
        //类别
        ProjectType: "",
        //以后销售佣金中抵扣
        LaterCommissionDeduction: false,
        //开发商名称
        DevelopersName: "",
        //对外分佣
        ExternalCommission: "",
        //转介费
        ReferralFee: "",
        //成交编号
        ContractNo: "",
        //盘源类型
        BuildType: "",
        //代理
        AgencyType: "",
        //品牌顾问策划项目
        BrandConsultantPlanningProject: false,
        //计佣区域
        CommissionArea: "",
        //申请变更日期
        ApplyChangeDate: "",
        //分佣比例类型
        CommissionRateType: "",
        //分佣比例id
        CommissionRateTypeId: "",
        HeaderExtensions: [],
      };
      if (this.status == "Apply" && this.resData.body.dataType != 20) {
        var that = this;
        let cols = that.templateData.TemplateContent.Controls;
        let deptRecords = [];
        cols.forEach((col) => {
          if (col.Property.Title[0].Text.indexOf("数据填写") > -1) {
            deptRecords.push(col.Property.Title[0].Text.split("数")[0]);
          }
        });
        let rcordsMap = new Map();
        let myKes = [];
        let rcordsDisMap = new Map();
        deptRecords.forEach((deptRecord) => {
          cols.forEach((col) => {
            if (
              col.Property.Title[0].Text.indexOf(deptRecord) > -1 &&
              col.Property.Title[0].Text.indexOf("数据填写") < 0
            ) {
              if (rcordsMap.get(deptRecord) == undefined) {
                rcordsMap.set(deptRecord, [col.Config.Table.Children]);
              } else {
                let arr = rcordsMap.get(deptRecord);
                arr.push(col.Config.Table.Children);
                rcordsMap.set(deptRecord, arr);
              }
            }
          });
        });
        rcordsMap.forEach((value, key) => {
          myKes.push(key);
        });
        myKes.forEach((myKey) => {
          let arrs = rcordsMap.get(myKey);
          arrs.forEach((arr) => {
            arr.forEach((item) => {
              if (item.Property.Title[0].Text == "员工姓名") {
                if (item.Value == null || item.Value == "") {
                  rcordsDisMap.set(myKey, true);
                }
              }
            });
          });
        });
        var aPass = false;
        myKes.forEach((myKey) => {
          let isPass = rcordsDisMap.get(myKey);
          if (isPass == undefined) {
            aPass = true;
          }
        });
        let tips = [];
        let rcordsKeys = rcordsDisMap.keys();
        let rcordsArrs = [...rcordsKeys];
        let nextArr = myKes.filter(function (v) {
          return rcordsArrs.indexOf(v) == -1;
        });
        if (aPass) {
          nextArr.forEach((item) => {
            setTimeout(() => {
              this.Message({
                message: `${item}分佣信息不能全部填写`,
                type: "error",
                duration: 1200,
              });
            }, 200);
          });
          this.isDisabled = false;
          return;
        }

        let isExceed = false;
        let isDub = false;
        let bMap = new Map();
        let repeatMap = new Map();
        let repeat = false;
        let isMistaken = false;
        let errorMessage = "";
        cols.forEach((col) => {
          if (
            col.Property.Title[0].Text.indexOf("分佣信息") > -1 &&
            col.Property.Title[0].Text != "分佣信息"
          ) {
            let chils = col.Config.Table.Children;
            for (let i = 0; i < chils.length; i++) {
              if (chils[i].Property.Title[0].Text == "角色层级") {
                if (bMap.get(chils[i].Value) == undefined) {
                  bMap.set(chils[i].Value, Number(chils[i + 3].Value));
                } else {
                  bMap.set(
                    chils[i].Value,
                    this.add(bMap.get(chils[i].Value), Number(chils[i + 3].Value, 2))
                  );
                }
              }
            }
            for (let i = 0; i < chils.length; i++) {
              if (chils[i].Property.Title[0].Text == "角色层级") {
                if (repeatMap.get(chils[i].Value) == undefined) {
                  repeatMap.set(chils[i].Value, chils[i + 4].Value);
                } else {
                  let no = repeatMap.get(chils[i].Value);
                  if (no == chils[i + 4].Value) {
                    repeat = true;
                  }
                }
              }
            }
          }
        });
        // for (let i = 0; i < cols.length; i++) {
        //   let col = cols[i];
        //   if (col.Property.Title[0].Text.indexOf("分佣信息") > -1 &&
        //       col.Property.Title[0].Text !== "分佣信息") {
        //     let chils = col.Config.Table.Children;
        //     for (let i = 0; i < chils.length; i++) {
        //       if (chils[i].Property.Title[0].Text === "个人比率(%)") {
        //         let result = this.parseString(chils[i].Value);
        //         if (!Array.isArray(result)){
        //           errorMessage = result;
        //           isMistaken = true;
        //         }
        //       }
        //     }
        //   }
        // }
        bMap.forEach((value, key, map) => {
          if (value > 100) {
            isExceed = true;
          }
        });
        if (isMistaken) {
          this.Message({
            message: errorMessage,
            type: "error",
            duration: 3 * 1000,
          })
          this.isDisabled = false;
          return;
        }
        if (isExceed) {
          this.Message({
            message: "同一层级角色下所有人的比例相加不能超过100%",
            type: "error",
            duration: 3 * 1000,
          });
          this.isDisabled = false;
          return;
        }

        if (repeat) {
          this.Message({
            message: "同层级的员工不能重复",
            type: "error",
            duration: 3 * 1000,
          });
          this.isDisabled = false;
          return;
        }
        cols.forEach((col) => {
          if (
            col.Property.Title[0].Text.indexOf("分佣信息") > -1 &&
            col.Property.Title[0].Text != "分佣信息"
          ) {
            let chils = col.Config.Table.Children;
            let isRequired = false;
            for (var i = 0; i < chils.length; i++) {
              if (chils[i].Property.Title[0].Text == "个人比率(%)") {
                if (chils[i].Value != null && chils[i].Value != "") {
                  isRequired = true;
                }
              }
              if (chils[i].Property.Title[0].Text == "员工工号") {
                if (chils[i].Value != null && chils[i].Value != "") {
                  isRequired = true;
                }
              }
              if (chils[i].Property.Title[0].Text == "员工姓名") {
                if (chils[i].Value != null && chils[i].Value != "") {
                  isRequired = true;
                }
              }
            }
            if (isRequired) {
              chils.forEach((chil) => {
                if (chil.Property.Title[0].Text !== "备注") {
                  chil.Property.Require = 1;
                }
              });
            } else {
              chils.forEach((chil) => {
                if (chil.Property.Title[0].Text !== "备注") {
                  chil.Property.Require = 0;
                }
              });
            }
          }
        });
        cols.splice(15, 2);
        //数据校验
        if (!this.submitValidate(cols)) {
          this.isDisabled = false
          return;
        }
        let datafbs = [];

        cols.forEach((col) => {
          if (
            col.Property.Title[0].Text.indexOf("分佣信息") > -1 &&
            col.Property.Title[0].Text != "分佣信息"
          ) {
            let chils = col.Config.Table.Children;
            var datafb = {
              id: this.id,
              DeptName: "",
              RoleName: "",
              DeptRate: 0,
              RoleRate: 0,
              PersonRate: 0,
              EmpNo: "",
              EmpName: "",
              Remark: "",
              Describe: "",
              Signed: "",
              ApprovalStatus: "",
              Time: 1,
            };
            chils.forEach((chil) => {
              datafb.Signed = this.logInfo.EmpNo;
              let inx = col.Property.Title[0].Text.indexOf("门");
              datafb.DeptName = col.Property.Title[0].Text.substring(
                0,
                inx + 1
              );
              if (chil.Property.Title[0].Text == "角色层级") {
                datafb.RoleName = chil.Value;
              }
              if (chil.Property.Title[0].Text == "部门分佣比例") {
                datafb.DeptRate = chil.Value;
              }
              if (chil.Property.Title[0].Text == "角色计佣比例") {
                datafb.RoleRate = chil.Value;
              }
              if (chil.Property.Title[0].Text == "个人比率(%)") {
                if (Number(chil.Value) === 0) {
                  datafb.PersonRate = 0;
                } else {
                  datafb.PersonRate = Number((chil.Value / 100).toFixed(4));
                }
              }
              if (chil.Property.Title[0].Text == "员工工号") {
                chil.Property.Control = "Text";
                chil.filterable = false;
                if (chil.Value != null) {
                  datafb.EmpNo = chil.Value.split("-")[0];
                }
                delete chil.value;
              }
              if (chil.Property.Title[0].Text == "员工姓名") {
                datafb.EmpName = chil.Value;
              }
              if (chil.Property.Title[0].Text == "备注") {
                datafb.Remark = chil.Value;
              }
              datafb.Describe = "系统自动通过"
              datafb.ApprovalStatus = 200
            });
            if (
              datafb.DeptName !== null &&
              datafb.DeptName !== "" &&
              datafb.DeptRate !== null &&
              datafb.DeptRate !== "" &&
              datafb.EmpName !== null &&
              datafb.EmpName !== "" &&
              datafb.EmpNo !== null &&
              datafb.EmpNo !== "" &&
              datafb.PersonRate !== null &&
              datafb.RoleName !== null
            ) {
              datafbs.push(datafb);
            }
          }
        });
        if (!datafbs.length > 0) {
          cols.forEach((col) => {
            if (
              col.Property.Title[0].Text.indexOf("分佣信息") > -1 &&
              col.Property.Title[0].Text != "分佣信息"
            ) {
              let chils = col.Config.Table.Children;
              chils.forEach((chil) => {
                if (chil.Property.Title[0].Text == "员工工号") {
                  chil.Property.Control = "Selector";
                  chil.filterable = true;
                }
              });
            }
          });
          this.Message({
            message: "分佣信息不能全部为空！",
            type: "error",
            duration: 1000,
          });
          this.isDisabled = false;
          return;
        }

        getEmployeeFill(this.id, 1, datafbs).then((res) => {
          this.isDisabled = true;
          this.Message({
            message: "申请成功",
            type: "success",
            duration: 3 * 1000,
          });
          setTimeout(() => {
            this.$router.push("/index");
          }, 3000);
        }).catch(e => {
          this.isDisabled = false;
        });
      } else if (
        this.status == "AllocationFill" ||
        this.status == "BasicReject" ||
        this.resData.body.dataType == 20
      ) {
        var that = this;
        let cols = that.templateData.TemplateContent.Controls;

        cols.forEach((col) => {
          if (
            col.Property.Title[0].Text.indexOf("分佣信息") > -1 &&
            col.Property.Title[0].Text != "分佣信息"
          ) {
            let chils = col.Config.Table.Children;
            let isRequired = false;
            for (var i = 0; i < chils.length; i++) {
              if (chils[i].Property.Title[0].Text == "个人比率(%)") {
                if (chils[i].Value != null && chils[i].Value != "") {
                  isRequired = true;
                }
              }
              if (chils[i].Property.Title[0].Text == "员工工号") {
                if (chils[i].Value != null && chils[i].Value != "") {
                  isRequired = true;
                }
              }
              if (chils[i].Property.Title[0].Text == "员工姓名") {
                if (chils[i].Value != null && chils[i].Value != "") {
                  isRequired = true;
                }
              }
            }
            if (isRequired) {
              chils.forEach((chil) => {
                if (chil.Property.Title[0].Text !== "备注") {
                  chil.Property.Require = 1;
                }
              });
            }
          }
        });
        let isExceed = false;
        let isSize = false;
        let bMap = new Map();
        cols.forEach((col) => {
          if (
            col.Property.Title[0].Text.indexOf("分佣信息") > -1 &&
            col.Property.Title[0].Text != "分佣信息"
          ) {
            let chils = col.Config.Table.Children;
            for (let i = 0; i < chils.length; i++) {
              if (chils[i].Property.Title[0].Text == "角色层级") {
                if (bMap.get(chils[i].Value) == undefined) {
                  bMap.set(chils[i].Value, Number(chils[i + 3].Value));
                } else {
                  bMap.set(
                    chils[i].Value,
                    this.add(bMap.get(chils[i].Value), Number(chils[i + 3].Value, 2))
                  );
                }
              }
            }
          }
        });
        bMap.forEach((value, key, map) => {
          if (value > 100) {
            isExceed = true;
          }
        });
        if (isExceed) {
          this.Message({
            message: "同层级的个人比率不能超过100%",
            type: "error",
            duration: 3 * 1000,
          });
          this.isDisabled = false;
          return;
        }
        cols.splice(16, 2);
        //数据校验
        if (!this.submitValidate(cols)) {
          this.isDisabled = false;
          return;
        }
        let datafbs = [];
        cols.forEach((col) => {
          if (
            col.Property.Title[0].Text.indexOf("分佣信息") > -1 &&
            col.Property.Title[0].Text != "分佣信息"
          ) {
            let mySin = {
              Signed: "",
            };
            if (col.Signed != undefined) {
              mySin.Signed = col.Signed;
            } else {
              mySin.Signed = this.logInfo.EmpNo;
            }
            let chils = col.Config.Table.Children;
            var datafb = {
              id: this.id,
              DeptName: "",
              RoleName: "",
              DeptRate: 0,
              RoleRate: 0,
              PersonRate: 0,
              EmpNo: "",
              EmpName: "",
              Remark: "",
              Describe: "",
              Signed: mySin.Signed,
              Time: 0,
              approvalTime: null,
              approvalStatus: null,
            };
            if (this.status == "AllocationFill") {
              datafb.Time = 2;
            } else {
              datafb.Time = 1;
            }
            chils.forEach((chil) => {
              let inx = col.Property.Title[0].Text.indexOf("门");
              datafb.DeptName = col.Property.Title[0].Text.substring(
                0,
                inx + 1
              );
              if (chil.Property.Title[0].Text == "角色层级") {
                if (chil.Value != null) {
                  datafb.RoleName = chil.Value;
                }
              }
              if (chil.Property.Title[0].Text == "部门分佣比例") {
                if (chil.Value != null) {
                  datafb.DeptRate = chil.Value;
                }
              }
              if (chil.Property.Title[0].Text == "角色计佣比例") {
                if (chil.Value != null) {
                  datafb.RoleRate = chil.Value;
                }
              }
              if (chil.Property.Title[0].Text == "个人比率(%)") {
                if (chil.Value != null) {
                  datafb.PersonRate = Number((chil.Value / 100).toFixed(4));
                }
              }
              if (chil.Property.Title[0].Text == "员工工号") {
                chil.Property.Control = "Text";
                chil.filterable = false;
                if (chil.Value != null) {
                  datafb.EmpNo = chil.Value.split("-")[0];
                }
                delete chil.value
              }
              if (chil.Property.Title[0].Text == "员工姓名") {
                if (chil.Value != null) {
                  datafb.EmpName = chil.Value;
                }
              }
              if (chil.Property.Title[0].Text == "备注") {
                if (chil.Value != null) {
                  datafb.Remark = chil.Value;
                }
              }
            });
            let Vflag = `${datafb.EmpNo}-${datafb.DeptName}-${datafb.PersonRate}`;
            let status = this.statusMap.get(Vflag);
            if (status != undefined) {
              datafb.approvalStatus = parseInt(status.split("@")[0]);
              datafb.approvalTime = status.split("@")[1];
              datafb.Describe = "系统自动通过"
            }
            if (
              datafb.DeptName !== "" &&
              datafb.DeptRate !== "" &&
              datafb.EmpName !== "" &&
              datafb.EmpNo !== "" &&
              datafb.PersonRate !== "" &&
              datafb.RoleName !== "" &&
              datafb.EmpName !== ""
            ) {
              datafbs.push(datafb);
            }
          }
        });
        for (let i = 0; i < datafbs.length; i++) {
          if (datafbs[i].EmpNo === "A957" || datafbs[i].EmpNo === "A956" || datafbs[i].EmpNo === "A966"
            || datafbs[i].EmpNo === "A988" || datafbs[i].EmpNo === "ASCH01") {
            datafbs[i].Time = 1;
            datafbs[i].Describe = "系统自动通过"
          }
        }



        let transientTime = 0;
        if (this.status == "AllocationFill") {
          transientTime = 2;
        } else {
          transientTime = 1;
        }

        if (!datafbs.length > 0) {
          this.Message({
            message: "分佣信息未填写或当前没有权限",
            type: "error",
            duration: 1500,
          });
          this.isDisabled = false;
          return;
        }

        getEmployeeFill(this.id, transientTime, datafbs).then((res) => {
          this.isDisabled = true;
          this.Message({
            message: "申请成功",
            type: "success",
            duration: 3 * 1000,
          });
          setTimeout(() => {
            this.$router.push("/index");
          }, 3000);
        }).catch(e => {
          this.isDisabled = false;
        });
      }
    },
  },
  watch: {
    relationList(val, oldVal) {
      if (oldVal == null) {
        this.getTemplate();
      }
    },
  },
};
</script>

<style scoped lang="less">
.pages {
  padding-bottom: 14px;
}
</style>
